import * as React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Separator } from "@/components/ui/separator";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
const products = [{
  id: "p1",
  title: "Aceite Multi Varietal",
  description: "Una mezcla armoniosa de nuestras mejores aceitunas, perfecta para el uso diario en cocina y mesa.",
  profile: "Equilibrado y versátil",
  availability: "Disponible en 500ml",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/olive_oil_multivarietal.png",
  link: "/OurOilPage"
}, {
  id: "p2",
  title: "Aceite Picual",
  description: "Con carácter fuerte y notas picantes, ideal para potenciar el sabor de carnes y guisos.",
  profile: "Intenso y frutado",
  availability: "Edición Limitada",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/olive_oil_picual.png",
  link: "/OurOilPage"
}, {
  id: "p3",
  title: "Aceite Arbequina",
  description: "Suavidad excepcional con toques de almendra y manzana, perfecto para ensaladas y postres.",
  profile: "Suave y dulce",
  availability: "Disponible en 500ml",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/olive_oil_arbequina.png",
  link: "/OurOilPage"
}];
export default function OurCollection() {
  return <section id="nuestra-colección" className="bg-secondary py-10 md:py-9 lg:py-12">
      <div className="container mx-auto px-4 max-w-6xl">
        {}
        <div className="mb-20 text-center">
          <h2 className="font-serif text-[2.5rem] leading-tight text-foreground">
            Nuestra colección
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-16">
          {products.map((product, i) => <div key={product.id} data-index={i}>
              <Card className="border-0 bg-transparent h-full p-0">
                <CardHeader className="p-0 mb-8 border-none">
                  <Link to={product.link} className="block w-full group cursor-pointer">
                    <div className="w-full overflow-hidden bg-white/50">
                      <AspectRatio ratio={4 / 5}>
                        <img src={product.image} alt={product.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                      </AspectRatio>
                    </div>
                  </Link>
                </CardHeader>
                
                <CardContent className="p-0 flex flex-col gap-4">
                  <Link to={product.link} className="block group">
                    <CardTitle className="font-serif text-[2rem] leading-[1.35] font-normal text-foreground group-hover:text-primary-700 transition-colors">
                      {product.title}
                    </CardTitle>
                  </Link>
                  
                  <CardDescription className="font-sans text-base text-muted-foreground/90 leading-relaxed">
                    {product.description}
                  </CardDescription>
                  
                  <div className="font-sans text-base font-medium text-foreground">
                    Perfil: <span className="font-normal text-muted-foreground">{product.profile}</span>
                  </div>
                </CardContent>

                <CardFooter className="p-0 mt-6 flex flex-col items-start gap-4">
                  <Separator className="bg-foreground/10" />
                  <span className="text-[0.875rem] uppercase tracking-wider text-muted-foreground font-medium">
                    {product.availability}
                  </span>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}